import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { IconMintGoTo } from '@/assets';
import { useMintAndJump } from '@/views/Settings/components/UidSetting/state';

import styles from './index.module.scss';
import Button from '../Button';

export const MintWeb3IdBtn = ({
  onClick,
  className,
  disableLink,
}: {
  onClick?: () => void;
  className?: string;
  disableLink?: boolean;
}) => {
  const { t } = useTranslation();

  const mintAndJump = useMintAndJump();

  const handleClick = useCallback(() => {
    onClick?.();
    if (!disableLink) {
      mintAndJump();
    }
  }, [disableLink, onClick, mintAndJump]);

  return (
    <Button onClick={handleClick} className={clsx(styles.btn, className)} type="primary">
      {t('MintWeb3IdBtn.5eh9ot')}
      <IconMintGoTo className={styles.icon} />
    </Button>
  );
};
